module.exports = __webpack_public_path__ + "img/storage02.61335cae.jpg";